export default __webpack_public_path__ + "static/Fale-conosco-0f23f12575d08d795fded8fbf85090ae.svg";